import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e96f21f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Novo Cliente", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Insira os seus dados para cadastro de um novo cliente em nosso aplicativo ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mini" }, " O seu celular com DDD sera usado para acessos futuros ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonLabel,
  IonInput,
  IonList,
  IonItem,
  loadingController,
  IonCheckbox,
  alertController,
} from "@ionic/vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { key } from "../store";
import { useRouter } from "vue-router";
import axios from "axios";
// import { Loader } from "@googlemaps/js-api-loader";
import { maskito } from "@maskito/vue";
import { getCep } from "@/service/cep";
import { getCoordinate, getDistance } from "@/service/mapbox";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutClienteNovoForm',
  setup(__props) {

const vMaskito = maskito;

// const loader = new Loader({
//   apiKey: process.env.VUE_APP_GOOGLE_API,
//   version: "weekly",
// });

const telOptions = {
  mask: [
    "(",
    /[0-9]/,
    /[0-9]/,
    ")",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
  ],
};

const cepfOptions = {
  mask: [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
  ],
};

const store = useStore(key);
const router = useRouter();

const nome = ref("");
const cpf = ref("");
const email = ref("");
const endereco = ref("");
const numero = ref("");
const complemento = ref("");
const referencia = ref("");
const bairro = ref("");
const cidade = ref("");
const uf = ref("");
const cep = ref("");
const telefone1 = ref();
const longitude = ref();
const latitude = ref();

const lgpd = ref(false);

onMounted(() => {
  telefone1.value = store.state.user.fone;
});

async function showLoading() {
  const loading = await loadingController.create({
    message: "Cliente salvo com sucesso",
    duration: 800,
    spinner: "circles",
  });

  loading.present();
  // loading.onWillDismiss().then(()=>{
  //      console.log('return');
  //      router.push({name: 'checkoutcliente'})
  // })
}

const showError = async () => {
  const alert = await alertController.create({
    header: "Alerta",
    subHeader: "Não foi possivel criar o novo cliente",
    message: "Verifique os campos digitados!",
    buttons: ["OK"],
  });
  await alert.present();
};

// const geocodes = async (address: string) => {
//   const argsMaps = {
//     params: {
//       key: process.env.VUE_APP_GOOGLE_API,
//       address: address,
//     },
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//   };
//   const dataGeo = await axios
//     .get("https://maps.googleapis.com/maps/api/geocode/json", argsMaps)
//     .then((resp) => {
//       // const str = JSON.stringify(resp.data.results[0].geometry.bounds?.northeast);
//       // console.log(`First result is: ${str}`);
//       return resp.data.results[0].geometry.location;
//     })
//     .catch((err) => {
//       console.log(err);
//     });
//   return dataGeo;
// };

// const geomatrix = async (destlat: string, destlgn: string)=> {
//     const argsMapsDm = {
//         params: {
//             key: process.env.VUE_APP_GOOGLE_API,
//             origins: [{ lat: process.env.VUE_APP_STORE_LAT , lng: process.env.VUE_APP_STORE_LNG }],
//             destinations: [{ lat: destlat, lng: destlgn}]
//         },
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Accept': 'application/json',
//             'Content-Type': 'application/json'
//         }
//     };
//     const dataMatrix = await axios.get('https://maps.googleapis.com/maps/api/distancematrix/json', argsMapsDm).then((resp)=>{
//         // const str = JSON.stringify(resp.data.rows[0].elements[0].distance.value);
//         // console.log(`First result is: ${str}`);
//         return resp.data.rows[0].elements[0].distance.value;
//     }).catch(err => {
//         console.log(err)
//     });
//     return dataMatrix;
// }

// const geomatrix = async (destlat: any, destlgn: any) => {
//   const { TravelMode } = await loader.importLibrary("routes");
//   const { UnitSystem, LatLng } = await loader.importLibrary("core");

//   // const latlngDest = new LatLng(-3.7762, -38.57594);
//   // const latlngOrigins = new LatLng(-3.729711, -38.5028769);

//   const dd = await loader
//     .importLibrary("routes")
//     .then(({ DistanceMatrixService }) => {
//       const ms = new DistanceMatrixService();
//       const myDistance = ms
//         .getDistanceMatrix({
//           destinations: [
//             { lat: parseFloat(destlat), lng: parseFloat(destlgn) },
//           ], // [ destlat , destlgn ],
//           origins: [
//             {
//               lat: parseFloat(process.env.VUE_APP_STORE_LAT),
//               lng: parseFloat(process.env.VUE_APP_STORE_LNG),
//             },
//           ], // [ process.env.VUE_APP_STORE_LAT , process.env.VUE_APP_STORE_LNG ],
//           travelMode: TravelMode.DRIVING,
//           unitSystem: UnitSystem.METRIC,
//         })
//         .then((response) => {
//           return response.rows[0].elements[0].distance.value;
//         });
//       return myDistance;
//     })
//     .catch((e) => {
//       console.log(e);
//     });
//   return dd;
// };

async function salvarDadosNew() {
  if (
    lgpd.value == true &&
    nome.value != "" &&
    telefone1.value != "" &&
    email.value != "" &&
    cpf.value != "" &&
    endereco.value != "" &&
    numero.value != "" &&
    cep.value != ""
  ) {
    const endereco_busca = encodeURI(
      endereco.value + " " + numero.value + "," + cidade.value + "," + uf.value
    );
    const mapbox = await getCoordinate(endereco_busca);
    // console.log(mapbox.features[0].center);

    const distance = await getDistance(
      mapbox.features[0].center[1],
      mapbox.features[0].center[0]
    );
    const myditance = (distance.routes[0].distance)
    const datacli: Array<any> = [
      {
        nome: nome.value,
        telefone1: telefone1.value,
        email: email.value,
        cpf: cpf.value,
      },
      {
        endereco: endereco.value,
        numero: numero.value,
        complemento: complemento.value,
        referencia: referencia.value,
        bairro: bairro.value,
        cidade: cidade.value,
        uf: uf.value,
        cep: cep.value,
        latitude: mapbox.features[0].center[1],
        longitude: mapbox.features[0].center[0],
        distancia: myditance,
      },
    ];

    store.dispatch("saveClientNewData", datacli).then(() => {
      showLoading().then(() => {
        router.push({ name: "checkoutfinal" });
      });
    });
  } else {
    showError();
  }
}

watch(cep, async () => {
  if (cep.value.length === 8) {
    getCep(cep.value).then((dados) => {
      // console.log(dados);
      endereco.value = dados.logradouro;
      bairro.value = dados.bairro;
      cidade.value = dados.localidade;
      uf.value = dados.uf;
    });
  }
});

function formatCpf() {
  // console.log("kd");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2,
                  _hoisted_3,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Nome")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: nome.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nome).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Email")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "email",
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("CPF")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cpf.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cpf).value = $event)),
                            maxlength: "11",
                            inputmode: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Fone/Whatsapp")
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_unref(IonInput), {
                            modelValue: telefone1.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((telefone1).value = $event)),
                            disabled: "true"
                          }, null, 8, ["modelValue"]), [
                            [_unref(vMaskito), telOptions]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("CEP")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cep.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cep).value = $event)),
                            maxlength: "8",
                            inputmode: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Endereço")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: endereco.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endereco).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Número")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: numero.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((numero).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Complemento")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: complemento.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((complemento).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Referência")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: referencia.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((referencia).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Bairro")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: bairro.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((bairro).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cidade")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cidade.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((cidade).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Estado")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: uf.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((uf).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCheckbox), {
                            slot: "start",
                            modelValue: lgpd.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((lgpd).value = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_unref(IonLabel), { class: "mini" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Confirmo meus dados para cadastro "),
                              _hoisted_4,
                              _createTextVNode(" no APP Uniboi em acordo com a LGPD")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (salvarDadosNew()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Salvar novo cliente ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})